/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q40 → 1e-4 → 99.99% accuracy → Phred+33 char 'I'.`)
};

const es_phred_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q40 → 1e-4 → 99.99% de precisión → carácter Phred+33 'I'.`)
};

const de_phred_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q40 → 1e-4 → 99,99% Genauigkeit → Phred+33-Zeichen 'I'.`)
};

const nl_phred_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q40 → 1e-4 → 99,99% nauwkeurigheid → Phred+33-teken 'I'.`)
};

const fr_phred_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q40 → 1e-4 → 99,99 % de précision → caractère Phred+33 'I'.`)
};

const it_phred_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q40 → 1e-4 → 99,99% di accuratezza → carattere Phred+33 'I'.`)
};

const pt_br2_phred_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q40 → 1e-4 → 99,99% de precisão → caractere Phred+33 'I'.`)
};

const pt_phred_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q40 → 1e-4 → 99,99% de precisão → carácter Phred+33 'I'.`)
};

const ja_phred_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q40 → 1e-4 → 精度99.99% → Phred+33文字 'I'。`)
};

const zh_phred_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q40 → 1e-4 → 99.99% 准确率 → Phred+33 字符 'I'。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_ex3", locale)
	if (locale === "en") return en_phred_ex3(inputs)
	if (locale === "es") return es_phred_ex3(inputs)
	if (locale === "de") return de_phred_ex3(inputs)
	if (locale === "nl") return nl_phred_ex3(inputs)
	if (locale === "fr") return fr_phred_ex3(inputs)
	if (locale === "it") return it_phred_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_phred_ex3(inputs)
	if (locale === "pt") return pt_phred_ex3(inputs)
	if (locale === "ja") return ja_phred_ex3(inputs)
	return zh_phred_ex3(inputs)
};